<script>
  import EditView from '../base/EditView.vue'
  import FormInput from '../form/form-input.vue'

  export default {
    components: {
      EditView,
      FormInput,
    },
  }
</script>
<template>
  <edit-view store="company" list-route="CompanyList" v-slot:default="slotProps">
    <form-input :store="slotProps.store" prop-name="name" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="invoicePattern" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="customerPattern" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="projectPattern" class="col-3"></form-input>
  </edit-view>
</template>

